<div class="ili-panel pain_level_panel">
  <div class="mb-20 flex-row gap-[20px] sm:flex-col">
    <div>
      <mat-form-field class="inputInside w-full">
        <span matPrefix>* &nbsp;</span>
        <mat-checkbox value="true" [checked]="block.data.mandatory" [(ngModel)]="block.data.mandatory"
          (change)="onChange($event)" title='Field is mandatory'>
          <input matInput type="text" [(ngModel)]="block.data.question" class="form-control" (change)="onChange($event)"
            placeholder="{{'Enter Question here' | translate}}">
        </mat-checkbox>
      </mat-form-field>
    </div>
  </div>
  <div class="mb-20">
    <mat-radio-group aria-label="Select an option" [(ngModel)]="block.data.level" (change)="controlChange($event.value)"
      class="flex-col gap-[20px]">
      <mat-radio-button value="image" class="flex">{{'Numeric Rating Scale with Emoticons' |
        translate}}</mat-radio-button>
      <mat-radio-button value="numeric" class="flex">{{'Numeric Rating Scale' | translate}}</mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="mb-20 flex-row gap-[20px] sm:flex-col">
    <div class="survey_add_alert" *ngIf="block.data.confirmation && block.data.alerts && block.data.popup">
      <button mat-flat-button color="{{block.data.confirmation.length > 0 ? 'success' : 'primary'}}"
        (click)="addConfirm($event)" class="btn btn-info btn-xs survey-confirmation" style="display: block;">
        <mat-icon>check_circle</mat-icon> Add Confirmation
      </button>
      <button mat-flat-button color="{{block.data.alerts.length > 0 ? 'success' : 'primary'}}"
        (click)="addAlert($event)" class="btn btn-ques-alert btn-info btn-xs">
        <mat-icon>notification_important</mat-icon> Add Alert
      </button>
      <button mat-flat-button color="{{block.data.popup.length > 0 ? 'success' : 'primary'}}" (click)="addPopup($event)"
        class="btn btn-popup-alert btn-info btn-xs">
        <mat-icon>web_asset</mat-icon> Pop Up
      </button>
    </div>
  </div>
</div>